import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text/text';
import {WebSourceFavicon} from '../web-source-favicon/web-source-favicon';
import type {WebSourceRowProps} from './web-source-row.types';
import styles from './web-source-row.module.scss';

/** One cited page in the expanded list: favicon, domain and its number, over the page title. Opens in a new tab. */
export function WebSourceRow({source, position}: WebSourceRowProps): ReactElement {
  return (
    <li className={styles.webSourceRow}>
      <a className={styles.webSourceRowLink} href={source.url} target="_blank" rel="noopener noreferrer nofollow ugc">
        <span className={styles.webSourceRowMeta}>
          <WebSourceFavicon domain={source.domain} className={styles.webSourceRowFavicon} />
          <Text val={source.domain} size={TextSize.SM} className={styles.webSourceRowDomain} />
          <Text val={String(position)} size={TextSize.XS} bold className={styles.webSourceRowPosition} />
        </span>
        <Text val={source.title} size={TextSize.MD} bold className={styles.webSourceRowTitle} />
      </a>
    </li>
  );
}
